import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LeadAudit } from 'src/app/core/models/lead/lead-audit.model';

@Component({
    selector: 'sidenav-content-lead-info-audits-details',
    templateUrl: './sidenav-content-lead-info-audits-details.component.html',
    styleUrls: ['./sidenav-content-lead-info-audits-details.component.scss'],
    standalone: false
})
export class SidenavContentLeadInfoAuditsDetailsComponent implements OnInit {


  @Input() set audit(audit: LeadAudit | null | undefined) {
    this._audit = audit
  }

  @Output() close = new EventEmitter()

  _audit: LeadAudit | undefined | null = undefined

  constructor() { }

  ngOnInit(): void {
  }

  closeClicked() {
    this.close.emit(void 0)
  }

}
